import styled from "styled-components";
import { Text } from "@website-builder/ui/shared/elements";
import {
	DESKTOP_M_BP,
	DESKTOP_SM_BP,
	TABLET_BP,
} from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const StagedFormWrapper = styled.div`
	width: 540px;
	min-height: 540px;
	background-color: ${({ formStyles }) => formStyles.formBg};
	padding: 24px 28px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: auto;

	@media (max-width: ${DESKTOP_M_BP}px) and (min-width: ${DESKTOP_SM_BP}px) {
		width: 480px;
	}

	@media (max-width: ${DESKTOP_SM_BP}px) and (min-width: ${TABLET_BP}px) {
		width: 460px;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		width: 98%;
		max-width: 380px;
	}

	.staged-form {
		width: 90%;

		${({ isB2U }) =>
			isB2U &&
			`
      .help-text{
        font-size: 11px;
        font-weight: 400;
      }
      .boolean-input-text{
        & input{
          margin: 3px 5px 3px 0;
        }
        & p{
          font-size: 13px;
        }
      }
    `}
	}

	.stage-form-texts {
		color: ${({ formStyles }) => formStyles.textColor};
	}

	.form-consent {
		input {
			cursor: pointer;
			margin: 3px 5px 3px 0;
		}
		.form-consent-text-b2c,
		.form-consent-text-b2u > p {
			font-size: 13px;
			display: inline;
		}
	}

	.form-consent-link {
		margin-bottom: 0;
	}
	.boolean-input-text {
		display: flex !important;
		align-items: center;
	}

	.staged-form-course-selector {
		width: 100%;
		margin-top: 1rem;
	}
`;

export const Headline = styled(Text)`
	color: ${({ color }) => color};
	margin-bottom: 24px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 2rem;

	button {
		min-width: 120px;
	}
`;
export const ProgressBarWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	margin-bottom: 24px;
`;

export const ProgressBar = styled.div`
	width: 100%;
	max-width: 390px;
	height: 16px;
	background-color: ${({ color }) => color};
	border-radius: 10px;
	margin-top: 8px;
	margin-bottom: 8px;

	.progress {
		height: 100%;
		background-color: var(--primary-green-600);
		border-radius: 10px;
		transition: width 0.3s ease-in-out;
	}
`;

export const BackButtonWrapper = styled.div`
	width: 100%;
	text-align: center;

	.back-button {
		justify-content: center;
		margin-top: 16px;

		figure > svg > path {
			stroke: ${({ linkColor }) => linkColor};
			fill: ${({ linkColor }) => linkColor};
		}
	}

	.back-link-text {
		color: ${({ linkColor }) => linkColor};
		margin: 0;
	}
`;
